import { Link } from "react-router-dom";
import { readingModes } from "@/mocks/comics";

export default function Features() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold tracking-wide text-primary-500">核心能力</span>
        <h2 className="mt-2 text-2xl md:text-4xl">六种阅读姿势，怎么舒服怎么来</h2>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          不再被单一阅读方式束缚，翻页、下拉、目录、夜间、缓存、横屏，总有一种符合你的阅读习惯。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {readingModes.map((m, idx) => (
          <article
            key={m.title}
            className="group rounded-lg border border-background-200/70 bg-background-100 p-6 transition-colors hover:border-primary-300"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={m.icon} />
              </span>
              <span className="font-heading text-sm text-secondary-400">
                {String(idx + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg text-foreground-950">{m.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">{m.desc}</p>
          </article>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/features"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          了解全部阅读功能 <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}